import React from "react"
import PropTypes from "prop-types"
import TotalYear from "./charts/TotalYear"
import Profit from "./charts/Profit"
import Expenses from "./charts/Expenses"
import TotalBookingValue from "./charts/TotalBookingValue"
import Incomes from "./charts/Incomes"
import { Col, Row } from "antd"

Dashboard.propTypes = {
  params: PropTypes.object.isRequired,
  onChangeFilters: PropTypes.func.isRequired
}

export default function Dashboard({ params, onChangeFilters }) {
  return (
    <Row gutter={[16, 16]}>
      <Col span={24} md={12} xl={12} xxl={6}>
        <TotalBookingValue params={params} />
      </Col>
      <Col span={24} md={12} xl={12} xxl={6}>
        <Incomes params={params} />
      </Col>
      <Col span={24} md={12} xl={12} xxl={6}>
        <Expenses params={params} />
      </Col>
      <Col span={24} md={12} xl={12} xxl={6}>
        <Profit params={params} />
      </Col>
      <Col span={24}>
        <TotalYear />
      </Col>
    </Row>
  )
}
